<template>
    <!-- 截单确认 -->
    <div  class="orderPage">
        <div>
            <div class="tit">截单确认</div>
            <div class="zhuyi">
                <i class="el-icon-info"></i>
                你好，你已确认订舱信息请及时填写截单信息
            </div>
        </div>
        <div class="jindutiao">
            <el-steps :active="active" >
                <el-step icon="el-icon-success" title="截单待提交" :description="parentMessage.three_confirm_time"></el-step>
                <el-step icon="el-icon-success" title="截单已提交" :description="parentMessage.four_confirm_time"></el-step>
            </el-steps>
        </div>
        <div class="contenmt">
            <div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            起运港
                        </div>
                        <div class="nr-c">
                            {{parentMessage.pol_name}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            目的港
                        </div>
                        <div class="nr-c">
                            {{parentMessage.pod_name}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            航名/航次
                        </div>
                        <div class="nr-c">
                            {{parentMessage.vessel_voyage}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            ETD
                        </div>
                        <div class="nr-c">
                            {{parentMessage.etd}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            ETA
                        </div>
                        <div class="nr-c">
                            {{parentMessage.eta}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            船期
                        </div>
                        <div class="nr-c">
                            {{parentMessage.shipping_date}}天
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            运输条款
                        </div>
                        <div class="nr-c">
                            {{parentMessage.transportation_terms}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            箱源
                        </div>
                        <div class="nr-c">
                            {{parentMessage.box_source}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            提单类型
                        </div>
                        <div class="nr-c">
                            {{parentMessage.bill_of_lading_type_desc}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            截单时间
                        </div>
                        <div class="nr-c">
                            {{parentMessage.cutoff_bill_of_lading_time}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            进港/开港时间
                        </div>
                        <div>
                            <div class="nr-c">{{parentMessage.cyOpen}}</div>
                            <div class="yimatou">以码头实际时间为准</div>
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            截港时间
                        </div>
                        <div>
                            <div class="nr-c">{{parentMessage.cutoff_enter_the_port_time}}</div>
                            <div class="yimatou">以码头实际时间为准</div>
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            船代
                        </div>
                        <div class="nr-c">
                            {{parentMessage.ship_agency}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t ">
                            主单提单号
                        </div>
                        <div class="nr-c">
                            {{parentMessage.mawb_blno}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            分单提单号
                        </div>
                        <div class="nr-c">
                            {{parentMessage.split_blno}}
                        </div>
                    </div>
                    
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            航线
                        </div>
                        <div class="nr-c">
                            {{parentMessage.routeCd}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            目的港免堆/免用箱
                        </div>
                        <div class="nr-c">
                            {{parentMessage.freetime_desc}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            <span  v-if="showButton" class="xing">*</span>签单方式
                        </div>
                        <div  v-if="!showButton" class="nr-c">
                            {{parentMessage.signing_method}}
                        </div>
                        <el-select v-else  v-model="form.signing_method" placeholder="请选择">
                            <el-option 
                            v-for="(item,index) in signingList"
                            :key="index"
                            :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <!-- HS(海关编号) -->
            <div>
                <div class="con-tit">
                    HS(海关编号)
                </div>
                <div class="neirong">
                    <!-- v-for="(item,index) in parentMessage.hs"  -->
                    <div class="nr" 
                    v-for="(item,index) in parentMessage.hs" 
                    :key="index"
                    :class="{'nryi':index%3!=0}">
                        <div class="nr-t">
                            HS(海关编号)
                        </div>
                        <div class="nr-c">
                            {{item}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 集装箱信息 -->
            <div>
                <div class="con-tit">
                    集装箱信息
                </div>
                <el-table
                    :data="parentMessage.boxtype"
                    style="width: 100%"
                    :header-cell-style="{ background: '#f9f9f9' }"
                >
                    <el-table-column prop="box_no" label="箱号">
                        <template slot-scope="scope">
                            <span v-if="!showButton">{{scope.row.box_no}}</span>
                            <el-input v-else v-model="scope.row.box_no" placeholder="请输入"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="seal_no" label="封号" width="180">
                        <template slot-scope="scope">
                            <span v-if="!showButton">{{scope.row.seal_no}}</span>
                            <el-input v-else v-model="scope.row.seal_no" placeholder="请输入"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="box_type" label="箱型"> </el-table-column>
                    <el-table-column prop="weight" label="箱重(kgs)">
                        <template slot-scope="scope">
                            <span v-if="!showButton">{{scope.row.weight}}</span>
                            <el-input type="number" @change="changeBoxtotleweight" v-else v-model="scope.row.weight" placeholder="请输入"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 货物信息 -->
            <div>
                <div class="con-tit">
                    货物信息
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            <span  v-if="showButton" class="xing">*</span>包装单位
                        </div>
                        <div v-if="!showButton" class="nr-c">
                            {{parentMessage.packing_unit}}
                        </div>
                        <el-select v-else v-model="form.packing_unit" placeholder="请选择">
                            <el-option
                            v-for="item in packingList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            <span  v-if="showButton" class="xing">*</span>件数
                        </div>
                        <div class="nr-c"  v-if="!showButton">
                            {{parentMessage.quantity}}
                        </div>
                        <el-input
                            v-else
                            min='0' type="number"
                            @blur="onBlur"
                            v-model="form.quantity"
                            placeholder="请输入内容"
                        ></el-input>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            总重量(kgs)
                        </div>
                        <div class="nr-c">
                            {{parentMessage.totle_weight}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            <span  v-if="showButton" class="xing">*</span>体积(cbm)
                        </div>
                        <div class="nr-c"  v-if="!showButton">
                            {{parentMessage.totle_volume}}
                        </div>
                        <el-input 
                            v-else
                            min='0' type="number"
                            @blur="onBlur"
                            v-model="form.totle_volume"
                            placeholder="请输入内容"
                        ></el-input>
                    </div>
                    <div class="nr nryi xiaoInput">
                        <div class="nr-t">
                            <span  v-if="showButton" class="xing">*</span>唛头
                        </div>
                        <el-input :readonly="!showButton"  type="textarea" v-model="form.shipping_mark"></el-input>
                    </div>
                    <div class="nr nryi xiaoInput">
                        <div class="nr-t">
                            <span  v-if="showButton" class="xing">*</span>货物描述
                        </div>
                        <el-input :readonly="!showButton"  type="textarea" v-model="form.describe"></el-input>
                    </div>
                </div>
            </div>

            <!-- 收发通 -->
            <div>
                <div class="con-tit">
                    收发通
                    <el-button type="text" v-if="showButton" @click="getShoudatong">常用收发通</el-button>
                </div>
                <div class="neirong">
                    <div class="nr xiaoInput">
                        <div class="nr-t">
                            <span  v-if="showButton" class="xing">*</span>发货人
                        </div>
                        <el-input :readonly="!showButton"  type="textarea" v-model="form.shipper_mawb"></el-input>
                    </div>
                    <div class="nr nryi xiaoInput">
                        <div class="nr-t">
                            <span  v-if="showButton" class="xing">*</span>收货人
                        </div>
                        <el-input :readonly="!showButton"  type="textarea" v-model="form.consignee_mawb"></el-input>
                    </div>
                    <div class="nr nryi xiaoInput">
                        <div class="nr-t">
                            <span  v-if="showButton" class="xing">*</span>通知人
                        </div>
                        <el-input :readonly="!showButton"  type="textarea" v-model="form.notifier_mawb"></el-input>
                    </div>
                </div>
            </div>

            <!-- 订舱联系人 -->
            <div>
                <div class="con-tit">
                    订舱联系人
                </div>
                <div class="neirong yxnr">
                    <div class="nr">
                        <div class="nr-t">
                            订舱联系人
                        </div>
                        <div class="nr-c">
                            {{parentMessage.linkman}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            联系人电话
                        </div>
                        <div class="nr-c">
                            {{parentMessage.linkman_phone}}
                        </div>
                    </div>
                    <div class="nr youxiang"
                    v-for="(item,index) in parentMessage.email" 
                    :key="index">
                        <div class="nr-t">
                            联系人邮箱
                        </div>
                        <div class="nr-c">
                            {{item}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 截单备注 -->
            <div>
                <div class="con-tit">
                    截单备注
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            备注内容
                        </div>
                        <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="form.cut_off_remarks_user">
                        </el-input>
                    </div>
                </div>
            </div>

            <!-- 按钮们 -->
            <div class="sange">
                <!-- <el-button class="yulan">预览</el-button> -->
                <el-button class="daochu" @click="daochu">导出</el-button>
                <el-button v-if="showButton" class="daochu" @click="confirmQR">截单确认推送</el-button>
            </div>
        </div>

        <!-- 常用收发通 -->
        <el-dialog title="常用收发通" :visible.sync="dialogShoufatong">
            <el-table ref="tableShoufatong" :data="gridDataSoufatong">
                <el-table-column width="180" label="编号">
                <template slot-scope="scope">
                    <el-radio v-model="soufatongRadio" :label="scope.row.id+1"></el-radio>
                </template>
                </el-table-column>
                <el-table-column
                property="shipper"
                label="收货人"
                ></el-table-column>
                <el-table-column
                property="consignee"
                label="发货人"
                ></el-table-column>
                <el-table-column
                property="notifier"
                label="通知人"
                ></el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogShoufatong = false">返回</el-button>
                <el-button type="primary"  :disabled="soufatongRadio==''"  @click="useShoufatong "
                >使用</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
    
<script>
import { confirmCutOffInfo,createCutOffConfirmation,dict,getHistorySftInfoList } from "@/api/api";
export default {
    props:{
        parentMessage:{
            type:Object,
            required:true
        }
    },
    components:{
        
    },
    data() {
        return {
            active: 1,
            form:{
                order_id:'',
                cut_off_remarks_user:'', // 订舱备注-用户端 
                boxtype:'', // 箱型箱量信息
            },
            headers:{
                token: localStorage.getItem('token')
            },
            order_id: sessionStorage.getItem('itemId'),
            showButton:true,
            formMessage:{
                shipping_mark:'',
                describe:'',
                shipper_mawb:'',
                consignee_mawb:'',
                notifier_mawb:'',
            },
            // 包装单位列表
            packingList: [],
            // 签单方式
            signingList:[],
            //  常用收发通
            dialogShoufatong:false,
            gridDataSoufatong: [],
            soufatongRadio:'',
        }
    },
    methods: {
        // 总货重
        changeBoxtotleweight(){
            this.form.totle_weight = 0
            for (let i = 0; i < this.parentMessage.boxtype.length; i++) {
                this.form.totle_weight += Number(this.parentMessage.boxtype[i].weight)
            }
        },
        // 输入的数字大于0
        onBlur(e){
            // if(e.target.value<0){
            if(e.target.value == ''){
                return
            }
            if(!/\d$/.test(e.target.value)){
                this.$message({
                type:'error',
                message:'输入的内容应为数字'
                })
                return
            }
        },
        // 截单确认
        async confirmQR(){
            if(this.form.signing_method==''){
                this.$message({
                    type:'error',
                    message:'请选择签单方式'
                })
                return
            }else if(this.form.packing_unit==''){
                this.$message({
                    type:'error',
                    message:'请选择包装单位'
                })
                return
            }else if(this.form.quantity==''){
                this.$message({
                    type:'error',
                    message:'请输入件数'
                })
                return
            }else if(this.form.totle_volume==''){
                this.$message({
                    type:'error',
                    message:'请输入体积'
                })
                return
            }else if(this.form.shipping_mark==''){
                this.$message({
                    type:'error',
                    message:'请输入唛头'
                })
                return
            }else if(this.form.describe==''){
                this.$message({
                    type:'error',
                    message:'请输入货物描述'
                })
                return
            }
            else if(this.form.shipper_mawb==''){
                this.$message({
                    type:'error',
                    message:'请输入发货人信息'
                })
                return
            }
            else if(this.form.consignee_mawb==''){
                this.$message({
                    type:'error',
                    message:'请输入收货人信息'
                })
                return
            }
            else if(this.form.notifier_mawb==''){
                this.$message({
                    type:'error',
                    message:'请输入通知人信息'
                })
                return
            }else{
                for (let i = 0; i < this.parentMessage.boxtype.length; i++) {
                    if(this.parentMessage.boxtype[i].box_no==''){
                        this.$message({
                            type:'error',
                            message:'请输入集装箱箱号'
                        })
                        return
                    }else if(this.parentMessage.boxtype[i].seal_no==''){
                        this.$message({
                            type:'error',
                            message:'请输入集装箱封号'
                        })
                        return
                    }
                }
            }
            // confirmCutOffInfo
            this.$confirm('请仔细核对截单信息内容，避免因截单信息有误影响后续流程。若因截单信息确认偏差导致信息错误，需由自行承担。', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                try {
                    this.form.order_id=this.parentMessage.order_id
                    this.form.boxtype=this.parentMessage.boxtype
                    const res = await confirmCutOffInfo(this.form,this.headers)
                    if(res.code==1){
                        this.$message({
                            type:'success',
                            message:'截单确认成功'
                        })
                        this.showButton=false
                        this.active=2
                    }else{
                        this.$message({
                            type:'error',
                            message:res.msg
                        })
                    }
                } catch (error) {
                    console.log(error,'失败');
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
			});
        },
        async daochu(){
            try {
                const res = await createCutOffConfirmation({
                    order_id: this.$route.query.id
                },this.headers)
                if(res.code==1){
                    // this.form = res.data
                    this.$message({
                        type:'success',
                        message:'导出成功'
                    })
                    const link = document.createElement('a');
                    link.href = res.data.url;
                    link.setAttribute('download', '');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }else{
                    this.$message({
                        type:'error',
                        message:'导出失败'
                    })
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        async getPacking() {
            try {
                const res = await dict(
                    {
                        type: "packing_unit",
                    },
                    this.headers
                );
                if (res.code == 1) {
                    this.packingList = res.data.packing_unit;
                    this.signingList = res.data.signing_method;
                }
            } catch (error) {
                console.log(error, "失败");
            }
        },
        // 收发通
        async getShoudatong() {
            this.dialogShoufatong = true;
            
            try {
                const res = await getHistorySftInfoList(this.headers);
                if (res.code == 1) {
                this.gridDataSoufatong = res.data;
                for (let i = 0; i < this.gridDataSoufatong.length; i++) {
                    this.gridDataSoufatong[i].id = i
                }
                }
            } catch (error) {
                console.log(error, "失败");
            }
        },
        useShoufatong(){
            this.dialogShoufatong = false
            let data = this.gridDataSoufatong[this.soufatongRadio-1]
            this.form.shipper_mawb = data.shipper
            this.form.consignee_mawb = data.consignee
            this.form.notifier_mawb = data.notifier
            // this.soufatongRadio = ''
        },
    },
    mounted(){
        this.formMessage.shipping_mark = this.parentMessage.shipping_mark
        this.formMessage.describe = this.parentMessage.describe
        this.formMessage.shipper_mawb = this.parentMessage.shipper_mawb
        this.formMessage.consignee_mawb = this.parentMessage.consignee_mawb
        this.formMessage.notifier_mawb = this.parentMessage.notifier_mawb
        this.form = this.parentMessage
        this.form.cut_off_remarks_user=this.parentMessage.cut_off_remarks_user

        if( this.parentMessage.confirm_status==31 || this.parentMessage.confirm_status==4  || this.parentMessage.confirm_status==5){
            this.active=2
            this.showButton=false
        }
        this.getPacking()
    }
}
</script>
    
<style style lang="scss" scoped>

.tit{
    margin-top: 24px;
    font-size: 18px;
    color: #333333;
}

.zhuyi{
    font-size: 14px;
    color: #999999;

    margin-top: 10px;
    margin-bottom: 22px;
    .el-icon-info{
        color: #CCCCCC;
        font-size: 16px;
    }
}

.jindutiao{
    height: 174px;
    background: #F9F9F9;   

    .el-steps{
        padding-left: 32px;
        // height: 650px;
        width: 410px;
        margin: auto;
        padding-top: 48px;
    }
    :deep(.el-steps){
        .el-step__icon{
            background: #F9F9F9;
        }
    }
}



.contenmt{
    background: #fff;
    padding: 20px;

    .con-tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        padding-top: 12px;
        padding-bottom: 24px;

    }

    .neirong{
        display: flex;
        margin-bottom: 20px;
        // justify-content: space-between;
        .nr{
            display: flex;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            font-style: normal;
            text-transform: none;
        }

        .nryi{
          margin-left: 30px;  
        }


        .nr-t{
            // width: 100px;
            width: 85px;
            height: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #606260;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin-top: 10px;
        }

        

        .nr-c{
            width: 260px;
            height: 40px;
            background: #F9F9F9;
            border-radius: 9px 9px 9px 9px;
            
            padding: 10px 12px;

            box-sizing: border-box;

            
        }
        :deep(.el-input){
            width: 260px;
            height: 40px;
            input{
                width: 260px;
                height: 40px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;
                border: 0;
            }
        }

        :deep(.el-textarea){
            textarea{
                width: 1044px;
                height: 200px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;
                border: 0;
            }
        }

        .nr-cer{
            height: 120px;
            margin: 0;
            overflow:hidden;
            display: -webkit-box;  
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis; 
        }

        .nr-csan{
            width: 1044px;
            height: 200px;
            margin: 0;
        }

        .chakan{
            text-align: center;

            cursor: pointer;

            color: #0073F5;
        }

        .dongjie{
            display: flex;
            align-items: center;
            span{
                display: inline-block;

                width: 48px;
                height: 20px;
                background: #EDF6FF;
                border-radius: 4px 4px 4px 4px;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 10px;
                color: #0073F5;
                line-height: 20px;
                text-align: center;
                font-style: normal;
                text-transform: none;

                margin-left: 8px;
            }
        }

        .con-up{
            display: flex;
            align-items: center;
            justify-content: space-between;
            div{
                display: flex;
                align-items: center;
            }
            i{
                font-size: 16px;
                color: #00b53c;
                margin-right: 9px;
            }

            .name{
                width: 130px;

                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #333333;
                font-style: normal;
                text-transform: none;
            }

            .el-butnm{
                color: #0073F5;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                font-style: normal;
                text-transform: none;

                height: 18px;
                padding: 0;
            }
        }
    }
    .yxnr{
        flex-wrap: wrap;
        .nr{
            margin-bottom: 16px;
        }
    }

    .sange{
        text-align: center;
        .quxoia{
            width: 100px;
            height: 40px;
            border-radius: 8px 8px 8px 8px;
            background: #fff;
            font-size: 14px;
            color: #0073F5;
            border: 0;
        }
        .yulan{
            width: 100px;
            height: 40px;
            border-radius: 8px 8px 8px 8px;
            background: #fff;
            font-size: 14px;
            color: #0073F5;
            border: 1px solid #0073F5;
        }
        .daochu{
            min-width: 100px;
            height: 40px;
            border-radius: 8px 8px 8px 8px;
            background: #0073F5;
            font-size: 14px;
            color: #fff;
            border: 0;
        }
    }

    .xiaoInput{
        :deep(.el-textarea){
            width: 260px;
            background: #F9F9F9;
            border-radius: 9px 9px 9px 9px;
            .el-textarea__inner {
                width: 260px;
                height: 120px;
                background: #F9F9F9;
                border: 0;
            }
        }
    }
}

.table{
    width: 100%;
    border-spacing: 0;

    border-bottom: solid 1px #eee;

    margin-bottom: 20px;
    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }
}

.xing{
    color: #fe3300;
}

.yimatou{
  font-size: 12px;
  color: #999;
}
</style>